import { useMemo } from 'react';

import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';
import { useGetMakeById, useGetMakesWithNoModels } from 'Stores/MakesStore/MakesStore';
import { useGetModelById, useGetModels } from 'Stores/ModelsStore/ModelsStore';

export const INSIGHTS_OTHER_CATEGORY = 'Other';

export const useInsightsSection = () => {
	const { mainInfo } = useVehicleData();
	const getModelById = useGetModelById();
	const getMakeById = useGetMakeById();
	const models = useGetModels();
	const makesWithNoModelsStore = useGetMakesWithNoModels();

	const model = useMemo(() => {
		if (!mainInfo.modelId) {
			return models.find((modelObj) => {
				const makesFallbackOtherModel =
					modelObj.makeId === mainInfo.makeId && modelObj.name.toLowerCase() === INSIGHTS_OTHER_CATEGORY.toLowerCase();
				return makesFallbackOtherModel;
			});
		}
		return getModelById(mainInfo.modelId);
	}, [getModelById, mainInfo.makeId, mainInfo.modelId, models]);

	const make = useMemo(() => {
		return getMakeById(mainInfo.makeId);
	}, [getMakeById, mainInfo.makeId]);

	const modelName = useMemo(() => model?.name ?? INSIGHTS_OTHER_CATEGORY, [model]);

	const makeHasNoModels = useMemo(() => {
		if (!make) return true;
		return makesWithNoModelsStore.includes(make.name.toLowerCase());
	}, [make, makesWithNoModelsStore]);

	return { mainInfo, make, makeHasNoModels, model, modelName };
};
